import { SyntheticEvent } from "react";
import { NOOP_FN } from "@/constants/stable-empty";

export const withPreventDefaultAndStopPropagation =
  <T extends SyntheticEvent = SyntheticEvent, R = unknown>(callback: () => R) =>
  (evt: T): R => {
    evt.preventDefault();
    evt.stopPropagation();
    return callback();
  };

export const preventDefaultAndStopPropagation = withPreventDefaultAndStopPropagation(NOOP_FN);

export const withPreventDefault =
  <T extends SyntheticEvent = SyntheticEvent, R = unknown>(callback: () => R) =>
  (evt: T): R => {
    evt.preventDefault();
    return callback();
  };

export const preventDefault = withPreventDefault(NOOP_FN);

export const withStopPropagation =
  <T extends SyntheticEvent = SyntheticEvent, R = unknown>(callback: () => R) =>
  (evt: T): R => {
    evt.stopPropagation();
    return callback();
  };

export const stopPropagation = withStopPropagation(NOOP_FN);
